import { useEffect, useState } from 'react';
import { Tag } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { formatDraftCountdown } from '../utils/draftCountdown';

/** TCR-1963 — badge đếm ngược tự huỷ đơn Nháp, tự cập nhật mỗi phút. */
export function DraftCountdown({ expiresAt }: { expiresAt?: string | null }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);
  const label = formatDraftCountdown(expiresAt, now);
  if (!label) return null;
  return (
    <Tag
      icon={<ClockCircleOutlined />}
      color={label.urgent ? 'red' : 'orange'}
      data-testid="draft-countdown"
      style={{ whiteSpace: 'normal' }}
    >
      {label.text}
    </Tag>
  );
}
